import PropTypes, { object } from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { containerStyles } from 'styles/shared';
import SearchContainer from './SearchContainer';




const MultiSearchContainer = styled.div`
  width: 113.8rem;
  padding: 2rem 2.4rem 2rem 2.9rem;
  display: block;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5rem;
  ${containerStyles}

  @media (max-width: 1440px) {
    flex-wrap: wrap;
    height: auto;
    flex-direction: column;
    width: 54.4rem;
  }
`;

MultiSearchPanel.propTypes = {
  searchDetails: PropTypes.arrayOf(object).isRequired,
  isActiveSearch: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onSub: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isActiveSave: PropTypes.bool.isRequired,
  isActiveAdd: PropTypes.bool.isRequired,
};

function MultiSearchPanel({searchDetails,isActiveSearch,isActiveSave,isActiveAdd,onAdd,onSub,onSave,onChange,onSearch}) {
  
  function render() {
    return (
      <MultiSearchContainer>
        {searchDetails.map(row => {
          return <SearchContainer
            searchDetails={row}
            isActiveSearch={isActiveSearch}
            isActiveSave={isActiveSave}
            isActiveAdd={isActiveAdd}
            onAdd={onAdd}
            onSub={onSub}
            onSave={onSave}
            onChange={onChange}
            onSearch={onSearch}
            index={row.index} key={row.index}></SearchContainer>;
      })}

      </MultiSearchContainer>
      
    );
  }

  return render();
}

export default MultiSearchPanel;
